/** @type {import('tailwindcss').Config} */
module.exports = {
  important: true,
  content: [
    './app/modules/**/*.php',
    '!./app/modules/**/system/**',
    './app/layout/**/*.php',
    './app/layout/**/**/*.php',
    './app/public/js/*.js',
    './src/js/**/*.js',
    './src/js/*.js',
    './src-panel/js/**/*.js',
    './src-panel/js/*.js',
    './src-shop/js/**/*.js',
    './src-shop/js/*.js',
  ],
  theme: {
    screens: {
      xs: '360px',
      // => @media (min-width: 360px) { ... }

      sm: '640px',
      // => @media (min-width: 640px) { ... }

      md: '768px',
      // => @media (min-width: 768px) { ... }

      lg: '1024px',
      // => @media (min-width: 1024px) { ... }

      xl: '1280px',
      // => @media (min-width: 1280px) { ... }

      '2xl': '1536px',
      // => @media (min-width: 1536px) { ... }

      '3xl': '1800px',
      // => @media (min-width: 1800px) { ... }
    },

    extend: {
      colors: {
        transparent: 'transparent',
        current: 'currentColor',
      },
    },
  },
  plugins: [],
  safelist: [
    'w-full',
    'hidden',
    'sr-only',
    { pattern: /^grid-cols-/ },
    { pattern: /^col-span-/ },
    { pattern: /^flex-/ },
    { pattern: /^grid-/ },
    { pattern: /^justify-/ },
    { pattern: /^items-/ },
    { pattern: /^ml-/ },
    { pattern: /^mr-/ },
    { pattern: /^mb-/ },
  ],
};

/*Classes:
w-full - width: 100%;
hidden - display: none;
sr-only - hides visually, screen reader accessible;

flex - display: flex;
flex-wrap - flex-wrap: wrap;
justify-start - justify-content: flex-start;
justify-center - justify-content: center;
justify-end - justify-content: flex-end;
justify-between - justify-content: flex-between;
items-start - alight-items: flex-start;
items-center - alight-items: center;
items-end - alight-items: flex-end;
items-between - alight-items: flex-between;

grid - display: grid;
grid-cols-8 (1–8) – sets the parent to 8 grid columns.
col-span-8 (1–8) – makes the child span 8 columns.
col-span-full - makes the child span all columns.
* */
